import { ApiPromise } from '@/types';
import { HTTP } from '@/utils';
import { CreateMaterialPayload, UpdateMaterialPayload } from '@/types';

export default class AssessmentMaterialService {
  static resource = 'tenant/assessments';

  static createMaterial(assessmentId: number, payload: CreateMaterialPayload): ApiPromise {
    const formData = new FormData();
    formData.append('title', payload.title);
    formData.append('description', payload.description);
    formData.append('record_form_id', payload.record_form_id.toString());
    formData.append('document', payload.file);

    return HTTP.post(`${this.resource}/${assessmentId}/materials`, formData);
  }

  static updateMaterial(id: number, payload: UpdateMaterialPayload): ApiPromise {
    const formData = new FormData();
    formData.append('title', payload.title);
    formData.append('description', payload.description);
    formData.append('record_form_id', payload.record_form_id.toString());
    if (payload.file) {
      formData.append('document', payload.file);
    }

    return HTTP.post(`${this.resource}/materials/${id}`, formData);
  }

  static deleteMaterial(id: number): ApiPromise {
    return HTTP.delete(`${this.resource}/materials/${id}`);
  }
}
